// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__z11Cl","icon":"style_icon__1X-Nw"};